import { Activity, Menu, X } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useEffect, useState } from "react";
import { ROUTES } from '@/lib/routes';

export function PublicNav() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setIsLoggedIn(!!session));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => setIsLoggedIn(!!session));
    return () => subscription.unsubscribe();
  }, []);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/marketing", label: "Platform" },
    { to: ROUTES.PRICING, label: "Pricing" },
    { to: "/contact", label: "Contact" },
    { to: "/blog", label: "Blog" },
  ];

  return (
    <nav className="border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        <Link to={ROUTES.HOME} className="flex items-center gap-2 min-w-0">
          <Activity className="h-6 w-6 text-primary flex-shrink-0" />
          <span className="text-xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent truncate">
            AlphaSignal
          </span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link key={link.label} to={link.to} className="text-muted-foreground hover:text-foreground transition-colors text-sm">
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-1.5">
          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-md hover:bg-muted transition-colors"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>

          {isLoggedIn ? (
            <Link to={ROUTES.DASHBOARD}>
              <Button size="sm" className="bg-gradient-to-r from-primary to-primary-glow hover:opacity-90 transition-opacity text-xs sm:text-sm">
                Dashboard
              </Button>
            </Link>
          ) : (
            <>
              <Link to={ROUTES.AUTH} className="hidden sm:inline-flex">
                <Button variant="ghost" size="sm">Sign In</Button>
              </Link>
              <Link to="/get-started">
                <Button size="sm" className="bg-gradient-to-r from-primary to-primary-glow hover:opacity-90 transition-opacity text-xs sm:text-sm">
                  Get Started
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>

      {/* Mobile dropdown */}
      {mobileOpen && (
        <div className="md:hidden border-t border-border bg-background px-4 pb-4 space-y-1 animate-fade-in">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              onClick={() => setMobileOpen(false)}
              className="block py-2.5 px-3 rounded-md text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
            >
              {link.label}
            </Link>
          ))}
          {!isLoggedIn && (
            <Link
              to={ROUTES.AUTH}
              onClick={() => setMobileOpen(false)}
              className="block py-2.5 px-3 rounded-md text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
            >
              Sign In
            </Link>
          )}
        </div>
      )}
    </nav>
  );
}
